module.exports = __webpack_public_path__ + "img/home_big_img.c523a7b1.png";